import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AiAutocompletePlugin } from '../../aiAutocompletePluginType';
import { aiAutocompletePluginKey } from '../../ui/components/plugin-key';
import type { AiAutocompletePluginState } from '../../ui/types/types';

function isSuggestionVisibleState(state: AiAutocompletePluginState | undefined): boolean {
	return state?.status === 'suggestion';
}

/**
 * Hides the editor placeholder while an AI autocomplete ghost suggestion is visible
 * ({@link AiAutocompletePluginState} status <code>suggestion</code> only).
 */
export const createAiAutocompletePlaceholderControllerPlugin = (options: {
	api: ExtractInjectionAPI<AiAutocompletePlugin> | undefined;
}): SafePlugin => {
	const { api } = options;

	return new SafePlugin({
		view() {
			let previousSuggestionVisible = false;
			return {
				update(view) {
					if (!api?.placeholder || !api?.core) {
						return;
					}

					const pluginState = aiAutocompletePluginKey.getState(view.state);
					const suggestionVisible = isSuggestionVisibleState(pluginState);

					if (suggestionVisible !== previousSuggestionVisible) {
						previousSuggestionVisible = suggestionVisible;
						api.core.actions.execute(
							api.placeholder.commands.setPlaceholderHidden(suggestionVisible),
						);
					}
				},
			};
		},
	});
};
